import { render } from "./list-peserta.vue?vue&type=template&id=863e3a0a&scoped=true"
import script from "./list-peserta.vue?vue&type=script&lang=js"
export * from "./list-peserta.vue?vue&type=script&lang=js"

import "./list-peserta.vue?vue&type=style&index=0&id=863e3a0a&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-863e3a0a"]])

export default __exports__